<template>
  <el-card shadow="none">
    <el-table ref="multipleTable"
              :data="tableData">
      <el-table-column v-for="(item, index) in tableTitle"
                       :fixed="item.fixed"
                       :key="index"
                       :label="item.name"
                       :prop="item.prop"
                       :min-width="item.width"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column fixed="right"
                       label="操作"
                       :width="100">
        <template slot-scope="scope">
          <el-button v-has="'/facilitie_alarm/confirm'"
                     v-if="scope.row.status == '0'"
                     size="mini"
                     type="danger"
                     plain
                     @click="handleConfirm(scope.row)">确认</el-button>
        </template>

        <!-- <template slot-scope="scope">
          <el-popconfirm title="确定此事件已经处理完成？"
                         :key="scope.row.id"
                         @confirm="() => handleConfirm(scope.row)">
            <el-button v-has="'/facilitie_alarm/confirm'"
                       v-if="scope.row.status == '0'"
                       size="mini"
                       type="danger"
                       plain
                       slot="reference">确认</el-button>
          </el-popconfirm>
        </template> -->
      </el-table-column>
    </el-table>
    <Pagination :total="pagination.total"
                :pageSize="pagination.perPage"
                @handleSizeChange="handleSizeChange"
                @handleCurrent="handleCurrentChange"></Pagination>
  </el-card>
</template>

<script>
import fetch from '@/common/api'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { Pagination },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tableTitle: [
        {
          prop: 'time_str',
          name: '时间',
          width: '180'
        },
        {
          prop: 'typeStr',
          name: '事件类型',
          width: '180'
        },
        {
          prop: 'valStr',
          name: '事件名称',
          width: '180'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      confirmCount: 0
    }
  },
  created() {
    this.getList()
  },
  watch: {
    id(newf) {
      if (newf) {
        this.getList()
      }
    }
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getFacilitieAlarmList({
          facilityId: this.id,
          perPage: perPage,
          currentPage: currentPage
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 告警确认
    handleConfirm(row) {
      console.log(row.id)
      fetch.confirmFacilitieAlarm({ id: row.id, facilityId: row.facilityId }).then((data) => {
        data.procData(
          data.res,
          () => {
            // this.getList()
            this.confirmCount = this.confirmCount + 1
            this.$emit('confirm-count', this.confirmCount)
            row.status = '1'
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>